import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { ROUTES } from "../../../../../../constants";
import { getSecretQuestionCode } from "../../../../../store/personal-user";
import { findMessageForCode } from "../../../../../utils/secret-questions/map-codes-to-options";
import messages from "./secret-question-readonly-messages";

import "./secret-question-readonly.scss";

const block = "secret-question-readonly";

const SecretQuestionReadonly = () => {
  const { search } = useLocation();
  const secretQuestionCode = useSelector(getSecretQuestionCode);
  const secretQuestionMessage = findMessageForCode(secretQuestionCode);
  const changeSecretQuestionUrl = `${ROUTES.SECRET_QUESTION}${search}`;

  return (
    <>
      <dl className={`${block}`}>
        <dt className={`${block}__label text-control__label`}>
          <FormattedMessage {...messages.secretQuestion} />
        </dt>
        <dd className={`${block}__value`}>
          <FormattedMessage {...secretQuestionMessage} />
        </dd>
      </dl>

      <Link
        className={"change-secret-question-link hyperlink"}
        to={changeSecretQuestionUrl}
      >
        <FormattedMessage {...messages.changeSecretQuestion} />
      </Link>
    </>
  );
};

export default SecretQuestionReadonly;
